import React, { useState } from 'react';
import { Calendar, ChevronLeft, ChevronRight } from 'lucide-react';

// ============================================================================
// PERIOD SELECTOR — Composant partagé
// ============================================================================
// Props :
//   selectedDate   - Date object
//   onChange        - Callback (newDate: Date)
// ============================================================================

const PeriodSelector = ({ selectedDate, onChange }) => {
  const [showCalendar, setShowCalendar] = useState(false);

  const formatDateForDisplay = (date) => {
    return date.toLocaleDateString('fr-FR', {
      month: 'long',
      year: 'numeric',
    });
  };

  const goToPreviousMonth = () => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() - 1);
    onChange(newDate);
  };

  const goToNextMonth = () => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() + 1);
    onChange(newDate);
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 mb-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs font-semibold text-gray-600 mb-1">
            Période sélectionnée
          </div>
          <div className="text-lg font-bold text-gray-900 capitalize">
            {formatDateForDisplay(selectedDate)}
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={goToPreviousMonth}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>

          <div className="relative">
            <button
              onClick={() => setShowCalendar(!showCalendar)}
              className="flex items-center px-4 py-2 bg-white border border-gray-200 rounded-lg hover:border-gray-300 transition-colors font-medium"
            >
              <Calendar className="h-4 w-4 mr-2" style={{ color: '#88b9c5' }} />
              <span className="text-sm font-semibold">
                {formatDateForDisplay(selectedDate)}
              </span>
            </button>

            {showCalendar && (
              <div className="absolute top-full mt-2 right-0 bg-white rounded-xl shadow-lg border border-gray-100 z-50 p-4">
                <input
                  type="month"
                  value={`${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}`}
                  onChange={(e) => {
                    const [year, month] = e.target.value.split('-');
                    const newDate = new Date(parseInt(year), parseInt(month) - 1, 1);
                    onChange(newDate);
                    setShowCalendar(false);
                  }}
                  className="p-2 border border-gray-200 rounded-lg"
                />
              </div>
            )}
          </div>

          <button
            onClick={goToNextMonth}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PeriodSelector;